import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import dateFormats from '../../const/date-formats';
import { Fce } from '../../fce';
import moment from 'moment';

@Component({
  selector: 's-input-date',
  templateUrl: './s-input-date.component.html',
  styleUrls: ['./s-input-date.component.scss']
})
export class SInputDateComponent implements OnInit {

  @Input() class = ""
  @Input() model = null
  @Input() disabled = false
  @Input() required = false
  @Input() alertHoliday: boolean = false;
  @Input() type: string = "date"
  @Input() name: string = null
  @Input() minW: boolean = true;
  @Input() tabIndex: number = null;

  @Output() modelChange = new EventEmitter()
  @Output() change = new EventEmitter()
  @Output() blur = new EventEmitter()
  @Output() enter = new EventEmitter()

  placeholder = null
  dateFormat = null
  alert = null

  constructor() { }

  ngOnInit(): void {
    switch (this.type) {
      case 'week':
        this.placeholder = null
        this.dateFormat = dateFormats.WEEK
        break;
      case 'month':
        this.placeholder = null
        this.dateFormat = dateFormats.MONTH
        break;
      case 'year':
        this.placeholder = null
        this.dateFormat = dateFormats.YEAR
        break;
      case 'time':
        this.placeholder = dateFormats.SIMPLETIME
        this.dateFormat = dateFormats.SIMPLETIME
        break;
      case 'date':
        this.placeholder = dateFormats.DATE
        this.dateFormat = dateFormats.DEFAULT
        break;
      case 'datetime':
      case 'datetime-local':
        this.placeholder = dateFormats.DATETIME
        this.dateFormat = dateFormats.SERVER
        break;
    }
    this.calcAlert()
  }

  onChange() {
    this.modelChange.emit(this.model)
    // this.change.emit(this.model)
  }

  onBlur() {
    this.blur.emit(this.model)
  }

  onEnter() {
    this.enter.emit(this.model)
  }

  calcAlert() {
    if (this.alertHoliday) {
      this.alert = null
      if (this.model) {
        if (!this.model.getDate)
          this.parseDate(this.model)
        if (Fce.isWeekend(this.model))
          this.alert = 'date-is-weekend'
        else if (Fce.isHoliday(this.model))
          this.alert = 'date-is-holiday'
      }
    }
  }

  parseDate(dateString: string): void {
    let tmp
    switch (this.type) {
      case 'time':
        if (!this.model)
          this.model = new Date()
        const hhmm = dateString.split(":")
        if (hhmm?.length > 1) {
          this.model.setHours(hhmm[0])
          this.model.setMinutes(hhmm[1])
          this.model.setSeconds(0)
          this.model.setMilliseconds(0)
        } else {
          this.model.setHours(0)
          this.model.setMinutes(0)
          this.model.setSeconds(0)
          this.model.setMilliseconds(0)
        }
        break;
      case 'week':
        if (dateString) {
          tmp = moment(dateString, dateFormats.WEEK, true)
          if (tmp?.isValid())
            this.model = tmp.toDate()
        } else if (dateString == "")
          this.model = null
        break;
      case 'month':
        if (dateString) {
          tmp = moment(dateString, dateFormats.MONTH, true)
          if (tmp?.isValid())
            this.model = tmp.toDate()
        }
        break;
      default:
        this.model = dateString ? new Date(dateString) : null
        break;
    }
    this.calcAlert()
  }
}
